var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "clipboardButton"
  }, [_vm.noIcon ? _vm._t("default") : [_c('BaseButton', {
    class: (_class = {}, _class[_vm.$style.clipboardButtonRound] = _vm.theme === 'round', _class[_vm.$style.clipboardButtonSquare] = _vm.theme === 'square', _class),
    attrs: {
      "options": {
        defaultPadding: false
      },
      "theme": "white"
    },
    on: {
      "click": _vm.copyLinkToClipboard
    }
  }, [_c('MottoIcon', {
    attrs: {
      "name": _vm.icon,
      "icon-color": "gray"
    }
  })], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }